import { oneLineTrim } from 'common-tags';
import {
    limitAllParam as pageSizeAllParam,
} from 'app/react/state/middleware/api'

export const fetchAll = () => oneLineTrim`
    vehicle-types?
    ${pageSizeAllParam}
`;
